import React, { useState } from 'react'
import { rounder, percent, isNumeric } from '@lib/helpers'
import { Card } from 'react-bootstrap';
import { Trans } from '@lib/i18n'
import { Ico35 } from "@icons/new";
import ShareBar from '@components/scenario/ShareBar'

const JobsSectorsTable = ({ settori }) => {
  const [orderBy, setOrderBy] = useState(null)
  const [order, setOrder] = useState(1)
  const max = parseFloat(Math.max.apply(Math, settori.map(o => o.progress)))

  const handleOrderBy = key => () => {
    if (orderBy === key) setOrder(order * -1)
    else {
      setOrder(-1)
      setOrderBy(key)
    }
  }

  return <Card className="cards-utente d-none d-md-block card-table">
    <Card.Body>
      <Ico35 className="logo-card ico-box-blue" />
      <Card.Title><Trans code="A0205" /></Card.Title>
      <table className="investment-table">
        <thead>
          <tr>
            <th className="value-label" onClick={handleOrderBy('code')}><Trans code="A0191" /></th>
            <th className="value-label" onClick={handleOrderBy('industry')}><Trans code="A0068" /></th>
            <th onClick={handleOrderBy('value')}><Trans code="A0137" /></th>
            <th onClick={handleOrderBy('progress')}><Trans code="A0193" /></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {settori.sort((a, b) => {
            if (!orderBy) return 0
            if (isNumeric(a[orderBy]) && isNumeric(b[orderBy])) {
              a[orderBy] = parseFloat(a[orderBy])
              b[orderBy] = parseFloat(b[orderBy])
            }
            if (order === -1) {
              if (a[orderBy] < b[orderBy]) return -1
              if (a[orderBy] > b[orderBy]) return 1
              return 0
            } else {
              if (a[orderBy] < b[orderBy]) return 1
              if (a[orderBy] > b[orderBy]) return -1
              return 0
            }
          }).map((row, index) => (
            <tr key={index}>
              <td className="value-label">{row.code}</td>
              <td className="value-label">{row.industry}</td>
              <td>{rounder(row.value)}</td>
              <td>{percent(row.progress)}</td>
              <td className="value-label"><ShareBar max={max} value={row.progress} width={50} /></td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="va-desc"><Trans code="A0054" /></p>
    </Card.Body>
  </Card>
}

export default JobsSectorsTable